import { useState } from "react";
import { Share2, MessageSquare, Facebook, Twitter, Link2, Check } from "lucide-react";
import { HOME } from "@/constants/testIds";

const pill = "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/25 text-white text-sm transition-colors";

export const ShareButton = ({ name, url }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = `Check out the ${name} at PetTok Shop`;
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);

  const onShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: name, text, url });
        return;
      } catch (e) {
        if (e.name === "AbortError") return;
      }
    }
    setOpen((o) => !o);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this link:", url);
    }
  };

  return (
    <>
      <button data-testid={HOME.lightboxShare} onClick={onShare} className={`${pill} py-3 px-6 text-base`}>
        <Share2 size={16} /> Share
      </button>
      {open && (
        <div data-testid={HOME.shareMenu} className="basis-full mt-1 flex flex-wrap justify-center gap-2 fade-in">
          <a data-testid={HOME.shareSms} href={`sms:?&body=${t}%20${u}`} className={pill}><MessageSquare size={16} /> Text</a>
          <a data-testid={HOME.shareFacebook} href={`https://www.facebook.com/sharer/sharer.php?u=${u}`} target="_blank" rel="noopener noreferrer" className={pill}><Facebook size={16} /> Facebook</a>
          <a data-testid={HOME.shareX} href={`https://twitter.com/intent/tweet?text=${t}&url=${u}`} target="_blank" rel="noopener noreferrer" className={pill}><Twitter size={16} /> X</a>
          <button data-testid={HOME.shareCopy} onClick={copy} className={pill}>
            {copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? "Link copied" : "Copy link"}
          </button>
        </div>
      )}
    </>
  );
};
